<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/' + props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{
                    'v-breadcrumbs__item v-breadcrumbs__item--disabled':
                      props.item.disabled,
                  }"
                  >{{ props.item.text }}
                </router-link>
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">{{ responseError }}</span>
              </v-flex>
              <v-flex sm6>
                <v-menu
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="status != 'DRAFT'"
                >
                  <v-text-field
                    slot="activator"
                    label="IssueDate"
                    type="text"
                    prepend-icon="event"
                    v-model="issueDate"
                    readonly
                    :rules="rules.required('Issue date')"
                  ></v-text-field>
                  <v-date-picker
                    v-model="issueDate"
                    :rules="rules.required('Issue date')"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm6 v-if="storeReturnNote.id">
                <v-text-field
                  name="issueNo"
                  label="Issue No"
                  v-model="storeReturnNote.issueNo"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm6>
                <v-text-field
                  name="serialNo"
                  label="S/R No."
                  v-model="storeReturnNote.serialNo"
                  type="text"
                  :readonly="status != 'DRAFT'"
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="storeReturnNote.id">
                <v-select
                  v-model="storeReturnNote.status"
                  :items="statusList"
                  label="Choose Status..."
                  item-text="label"
                  item-value="value"
                  :rules="rules.required('Status')"
                  :readonly="status != 'DRAFT'"
                ></v-select>
              </v-flex>
              <v-flex sm6>
                <v-autocomplete
                  v-model="storeReturnNote.shopId"
                  :items="shopList"
                  label="Choose Shop..."
                  item-text="name"
                  item-value="id"
                  menu-props="auto"
                  color="blue-grey lighten-2"
                  :rules="rules.required('Shop')"
                  :readonly="
                    status != 'DRAFT' || checkUserShop() ? true : false
                  "
                ></v-autocomplete>
              </v-flex>
              <v-flex sm6>
                <v-autocomplete
                  v-model="storeReturnNote.departmentId"
                  :items="departmentList"
                  color="blue-grey lighten-2"
                  label="Choose Department..."
                  item-text="name"
                  menu-props="auto"
                  item-value="id"
                  :rules="rules.required('Department')"
                  :readonly="status != 'DRAFT'"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm6>
                <v-autocomplete
                  v-model="storeReturnNote.warehouseId"
                  :items="warehouseList"
                  label="Choose Warehouse..."
                  item-text="name"
                  item-value="id"
                  :hide-no-data="true"
                  menu-props="auto"
                  color="blue-grey lighten-2"
                  :rules="rules.required('Warehouse')"
                  @change="changeWarehouse"
                  :readonly="
                    status != 'DRAFT' || checkUserWarehouse() ? true : false
                  "
                ></v-autocomplete>
              </v-flex>
              <v-flex sm6>
                <v-autocomplete
                  v-model="storeReturnNote.binId"
                  :items="binList"
                  label="Choose Bin..."
                  item-text="name"
                  item-value="id"
                  :hide-no-data="true"
                  menu-props="auto"
                  color="blue-grey lighten-2"
                  :rules="rules.required('Bin')"
                  :readonly="status != 'DRAFT'"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm12>
                <v-textarea
                  name="Reason"
                  label="Reason"
                  v-model="storeReturnNote.reason"
                  counter
                  rows="2"
                  :rules="rules.reasonRules"
                  :readonly="status != 'DRAFT'"
                ></v-textarea>
              </v-flex>
              <v-flex sm6 v-if="storeReturnNote.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm6 v-if="storeReturnNote.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="storeReturnNote.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="storeReturnNote.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm6 v-if="storeReturnNote.id">
                <v-text-field
                  name="updateBy"
                  label="Updated By"
                  v-model="storeReturnNote.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex>
                <v-layout row wrap>
                  <v-btn
                    color="success"
                    @click="showProductListDialog = !showProductListDialog"
                    :disabled="status != 'DRAFT'"
                  >
                    Add Item
                    <v-icon right>add</v-icon>
                  </v-btn>
                </v-layout>

                <!-- details table -->
                <v-card>
                  <v-card-title>
                    <v-flex xs4>
                      <v-text-field
                        v-model="detailCodeSearch"
                        append-icon="search"
                        placeholder="Enter product code"
                        label="Search"
                        single-line
                        hide-details
                      ></v-text-field>
                    </v-flex>
                  </v-card-title>

                  <v-data-table
                    :headers="detailHeaders"
                    :items="detailList"
                    class="elevation-1"
                  >
                    <template v-slot:items="props">
                      <td style="text-align: left">
                        {{ props.item.productCode }}
                      </td>
                      <td style="text-align: left">
                        {{ props.item.productName }}
                      </td>
                      <td style="text-align: left">
                        {{ props.item.factorUnitName }}
                      </td>
                      <td style="text-align: right">
                        {{ props.item.qty | decFormat(6) }}
                      </td>
                      <td style="text-align: right">
                        {{ props.item.issueQty | decFormat(6) }}
                      </td>
                      <td style="text-align: right">
                        {{ props.item.unitCost | decFormat(6) }}
                      </td>
                      <td style="text-align: right">
                        {{
                          (props.item.qty * props.item.unitCost) | decFormat(6)
                        }}
                      </td>
                      <td width="10px">{{ props.item.jobNo }}</td>
                      <td>{{ props.item.remark }}</td>

                      <!-- actions -->
                      <td>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              flat
                              icon
                              color="blue lighten-2"
                              @click="editDetail(props.item)"
                              v-bind="attrs"
                              v-on="on"
                              :disabled="status != 'DRAFT'"
                            >
                              <v-icon>edit</v-icon>
                            </v-btn>
                          </template>
                          <span>Edit</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              @click="removeDetail(props.item.id)"
                              v-bind="attrs"
                              v-on="on"
                              :disabled="status != 'DRAFT'"
                            >
                              <v-icon>cancel</v-icon>
                            </v-btn>
                          </template>
                          <span>delete</span>
                        </v-tooltip>
                      </td>
                      <td></td>
                    </template>
                  </v-data-table>
                </v-card>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn
                    color="error"
                    @click="clear"
                    :disabled="storeReturnNote.id ? true : false"
                  >
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    :loading="saveLoading"
                    :disabled="!valid || status != 'DRAFT'"
                    type="submit"
                  >
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>

    <!--edit store return note detail dialog-->
    <v-dialog
      v-model="storeReturnNoteDetailDialog"
      scrollable
      max-width="1000px"
      persistent
    >
      <v-card>
        <v-card-title class="blue darken-3">
          <span class="title white--text">Store Return Note Detail</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="detailForm" v-model="detailValid" lazy-validation>
            <v-layout row wrap>
              <v-flex xs4 pa-1>
                <v-text-field
                  name="productCode"
                  label="Product Code"
                  v-model="selectedProduct.productCode"
                  :rules="rules.codeRules"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs8 pa-1>
                <v-text-field
                  name="productName"
                  label="Product Name"
                  v-model="selectedProduct.productName"
                  :rules="rules.nameRules"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs4 pa-1>
                <v-autocomplete
                  v-model="selectedProduct.factorUnitName"
                  :hide-no-data="true"
                  :items="selectedProduct.productUnits"
                  color="blue-grey lighten-2"
                  label="Unit"
                  item-value="factorUnitName"
                  item-text="factorUnitName"
                  menu-props="auto"
                  @change="(option) => initPrice(option)"
                  :rules="rules.required('Unit')"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs4 pa-1>
                <v-text-field
                  name="qty"
                  label="Qty"
                  v-model="selectedProduct.qty"
                  type="number"
                  min="0"
                  :rules="rules.geraterThanZeroQtyRules('Qty')"
                ></v-text-field>
              </v-flex>
              <v-flex xs4 pa-1>
                <v-text-field
                  name="unitCost "
                  label="Unit Cost"
                  v-model="selectedProduct.unitCost"
                  type="number"
                  min="0"
                  :rules="rules.unitCostRules"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 pa-1>
                <v-text-field
                  name="jobNo"
                  label="Job No"
                  type="text"
                  v-model="selectedProduct.jobNo"
                  :rules="rules.jobNoRules"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 pa-1>
                <v-text-field
                  name="remark"
                  label="Remark"
                  type="text"
                  v-model="selectedProduct.remark"
                  :rules="rules.remarkRules"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <div class="text-xs-center">
                  <v-btn
                    color="error"
                    @click="
                      storeReturnNoteDetailDialog = !storeReturnNoteDetailDialog
                    "
                  >
                    Close
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    :loading="saveDetailLoading"
                    :disabled="!detailValid || saveDetailLoading"
                    @click="addDetail"
                  >
                    Add
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!--product list dialog-->
    <ProductListDialog
      :showDialog="showProductListDialog"
      :params="{ status: 'ACTIVE' }"
      @close="closeProductDialog"
    ></ProductListDialog>
  </v-container>
</template>
  
  <script>
import ProductListDialog from "../dialogs/ProductListDialog.vue";
import { storeReturnNoteService } from "../../services/store-return-note-service";
import { StoreReturnNote, StoreReturnNoteDetail } from "../../models/model";
import { StoreReturnNoteFormRules } from "../../helpers/validation-rules";
import { commonService } from "../../services/common-service";
import { departmentService } from "../../services/department-service";
import { shopService } from "../../services/shop-service";
import { warehouseService } from "../../services/warehouse-service";

export default {
  name: "StoreReturnNoteDetail",
  components: { ProductListDialog },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    valid: true,
    saveLoading: false,
    saveDetailLoading: false,
    showProductListDialog: false,
    storeReturnNoteDetailDialog: false,
    detailValid: true,
    breadcrumbs: [
      {
        text: "Store Return Note",
        disabled: false,
        to: "store-return-notes",
      },
      {
        text: "Store Return Note Detail",
        disabled: true,
      },
    ],
    detailHeaders: [
      { text: "Code", align: "left", sortable: false },
      { text: "Product", align: "left", sortable: false },
      { text: "Unit", align: "left", sortable: false },
      { text: "Qty", align: "right", sortable: false },
      { text: "Issue Qty", align: "right", sortable: false },
      { text: "Unit Cost", align: "right", sortable: false },
      { text: "Amount", align: "right", sortable: false },
      { text: "Job No", align: "left", sortable: false },
      { text: "Remark", align: "left", sortable: false },
      { text: "Action", sortable: false },
    ],
    statusList: [
      { label: "DRAFT", value: "DRAFT" },
      { label: "CONFIRM", value: "CONFIRM" },
      { label: "CANCEL", value: "CANCEL" },
    ],
    rules: new StoreReturnNoteFormRules(),
    storeReturnNote: new StoreReturnNote(),
    oldStoreReturnNote: new StoreReturnNote(),
    selectedProduct: new StoreReturnNoteDetail(),
    updatedDate: "",
    createdDate: "",
    issueDate: "",
    responseError: "",
    status: "DRAFT",
    detailCodeSearch: "",
    departmentList: [],
    shopList: [],
    warehouseList: [],
    binList: [],
  }),
  computed: {
    detailList() {
      return this.storeReturnNote.storeReturnNoteDetailList.filter((d) => {
        if (this.detailCodeSearch)
          return (
            d.productCode
              .toLowerCase()
              .indexOf(this.detailCodeSearch.toLowerCase()) > -1
          );
        else return true;
      });
    },
  },
  created() {
    this.storeReturnNote.warehouseId = this.checkUserWarehouse();
    this.storeReturnNote.shopId = this.checkUserShop();
    this.getShopList();
    this.getDepartmentByStatus();

    const id = this.$route.params.id;
    if (id == "new") {
      // new StoreReturnNote
      this.issueDate = commonService.formatDate(
        new Date().toISOString().substring(0, 10),
        "YYYY-MM-DD"
      );
      this.getActiveWarehouse().then(() => {
        if (this.storeReturnNote.warehouseId) {
          this.getWarehouseBinList();
        }
      });
    } else {
      this.getStoreReturnNoteDetail(id);
    }
  },
  methods: {
    checkUserShop() {
      if (
        this.user.role.roleName == "BRANCH_ADMIN" ||
        this.user.role.roleName == "PRODUCTION_MANAGER"
      ) {
        return this.user.shopId;
      } else {
        return "";
      }
    },
    checkUserWarehouse() {
      if (
        this.user.role.roleName == "BRANCH_ADMIN" ||
        this.user.role.roleName == "WAREHOUSE_MANAGER" ||
        this.user.role.roleName == "WAREHOUSE_STAFF"
      ) {
        return this.user.warehouseId;
      } else if (this.user.roleName == "PRODUCTION_MANAGER") {
        return this.user.shop.warehouseId;
      } else {
        return "";
      }
    },
    getShopList() {
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getDepartmentByStatus() {
      departmentService
        .getDepartmentsByStatus("ACTIVE")
        .then((res) => {
          this.departmentList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getActiveWarehouse() {
      return warehouseService
        .getWarehousesByStatus("ACTIVE")
        .then((res) => {
          this.warehouseList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    changeWarehouse() {
      this.storeReturnNote.binId = "";
      this.binList = [];
      this.getWarehouseBinList();
    },
    getWarehouseBinList() {
      if (this.user.roleName == "WAREHOUSE_STAFF") {
        this.binList = this.user.selectedBinList;
      } else {
        let warehouse = commonService.search(
          "id",
          this.storeReturnNote.warehouseId,
          this.warehouseList
        );
        if (warehouse) {
          this.binList = warehouse.binList;
        }
      }
    },
    generateId() {
      let duplicateFlag = true;
      let id;

      // generate random id until it's unique
      while (duplicateFlag) {
        id = Math.floor(Math.random() * 9999 + 1);

        // find if id is duplicated
        let duplicateDetail =
          this.storeReturnNote.storeReturnNoteDetailList.find(
            (d) => d.id == id
          );
        if (!duplicateDetail) duplicateFlag = false;
      }
      return id;
    },
    closeProductDialog(product) {
      if (!(JSON.stringify(product) === "{}")) {
        this.selectedProduct = new StoreReturnNoteDetail();
        this.selectedProduct.isNew = true;
        this.selectedProduct.id = this.generateId();
        this.selectedProduct.productId = product.id;
        this.selectedProduct.productCode = product.code;
        this.selectedProduct.productName = product.name;
        this.selectedProduct.productUnits = product.productUnits;
        var basicProductUnit = product.productUnits.find(
          (v) => v.basicUnit == true
        );
        if (basicProductUnit) {
          this.selectedProduct.productUnitId = basicProductUnit.id;
          this.selectedProduct.factorUnitName = basicProductUnit.factorUnitName;
          this.selectedProduct.unitCost = basicProductUnit.unitCost;
        }
        this.storeReturnNoteDetailDialog = true;
      }
      this.showProductListDialog = false;
    },
    initPrice(factorUnitName) {
      let productUnit = commonService.search(
        "factorUnitName",
        factorUnitName,
        this.selectedProduct.productUnits
      );

      this.selectedProduct.productUnitId = productUnit.id;
      this.selectedProduct.unitCost = productUnit.unitCost;
    },
    addDetail() {
      if (this.$refs.detailForm.validate()) {
        this.saveDetailLoading = true;
        const index = this.storeReturnNote.storeReturnNoteDetailList
          .map((d) => d.id)
          .indexOf(this.selectedProduct.id);
        if (index > -1) {
          this.storeReturnNote.storeReturnNoteDetailList.splice(
            index,
            1,
            this.selectedProduct
          );
        } else {
          this.storeReturnNote.storeReturnNoteDetailList.unshift(
            this.selectedProduct
          );
        }

        this.saveDetailLoading = false;
        this.storeReturnNoteDetailDialog = !this.storeReturnNoteDetailDialog;
      }
    },
    editDetail(storeReturnNoteDetail) {
      this.selectedProduct = JSON.parse(JSON.stringify(storeReturnNoteDetail));
      this.storeReturnNoteDetailDialog = true;
    },
    removeDetail(storeReturnNoteDetailId) {
      const index = this.storeReturnNote.storeReturnNoteDetailList
        .map((d) => d.id)
        .indexOf(storeReturnNoteDetailId);

      if (!this.storeReturnNote.storeReturnNoteDetailList[index].isNew) {
        if (!this.storeReturnNote.deleteStoreReturnNoteDetailIds) {
          this.storeReturnNote.deleteStoreReturnNoteDetailIds = [];
        }
        this.storeReturnNote.deleteStoreReturnNoteDetailIds.push(
          storeReturnNoteDetailId
        );
      }
      this.$delete(this.storeReturnNote.storeReturnNoteDetailList, index);
    },
    onSave() {
      if (this.$refs.form.validate()) {
        if (!this.saveLoading) {
          this.saveLoading = true;
          let storeReturnNoteObj = this.storeReturnNote;
          storeReturnNoteObj.issueDateInMilliSeconds =
            commonService.convertToMilliseconds(this.issueDate);
          storeReturnNoteObj.storeReturnNoteDetailList.forEach((detail) => {
            if (detail.isNew) detail.id = null;
          });

          storeReturnNoteService
            .saveStoreReturnNote(storeReturnNoteObj)
            .then((res) => {
              console.log(res);
              this.goBack();
            })
            .catch((err) => {
              console.log(err);
              if (err.response.data) {
                this.responseError = err.response.data.message;
              }
              this.saveLoading = false;
            });
        }
      }
    },
    getStoreReturnNoteDetail(id) {
      storeReturnNoteService
        .getStoreReturnNoteDetail(id, true)
        .then((res) => {
          this.storeReturnNote = res.data;
          this.status = res.data.status;
          this.createdDate = commonService.millisecondToDate(
            this.storeReturnNote.createdDateInMilliSeconds,
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.millisecondToDate(
            this.storeReturnNote.updatedDateInMilliSeconds,
            "YYYY-MM-DD"
          );
          this.issueDate = commonService.millisecondToDate(
            this.storeReturnNote.issueDateInMilliSeconds,
            "YYYY-MM-DD"
          );

          //if inactive, add in list to show in UI
          if (res.data.bin) {
            this.binList.push(res.data.bin);
          }
          if (res.data.department) {
            this.departmentList.push(res.data.department);
          }
          if (res.data.warehouse) {
            this.warehouseList.push(res.data.warehouse);
          }

          this.getActiveWarehouse().then(() => {
            this.getWarehouseBinList();
          });
          this.oldStoreReturnNote = Object.assign({}, res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    clear() {
      this.$refs.form.resetValidation();
      this.responseError = "";
      if (!this.storeReturnNote.id) {
        this.storeReturnNote = new StoreReturnNote();
      } else {
        this.storeReturnNote = Object.assign({}, this.oldStoreReturnNote);
      }
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
  
  